import { ImageWithPlaceholder } from '@/common/components/ImageWithPlaceholder'
import { EstablishmentCompanyData } from '@/common/types/establishment/company.type'
import { BriefcaseBusinessIcon } from 'lucide-react'

type EstablishmentDetailsProps = {
  establishment?: EstablishmentCompanyData
}

export const EstablishmentDetails = ({ establishment }: EstablishmentDetailsProps) => {
  return (
    <div className="flex gap-2 items-center">
      <ImageWithPlaceholder
        className="size-8"
        iconClassName="size-6"
        url={establishment?.general_information?.company_logo?.url}
        placeholderIcon={BriefcaseBusinessIcon}
      />
      <p className="font-bold text-sm">{establishment?.general_information?.fantasy_name}</p>
    </div>
  )
}
